import { FlexBox } from 'shared/components/Base/Base'
import { TeamV3 } from 'shared/models/team'

import { UserLink } from '../User/UserLink'
import { TeamPage, TeamPageTab } from './TeamPage'

interface TeamCtonCtPageProps {
  team: TeamV3
  permissions: any
  isInsideSidebar?: boolean
}

export function TeamCtonCtPage({ team, permissions, isInsideSidebar }: TeamCtonCtPageProps) {
  return (
    <FlexBox mt={2} mb={4}>
      <TeamPage
        team={team}
        permissions={permissions}
        tabs={[TeamPageTab.EQUIPMENT, TeamPageTab.MEMBERS]}
        isInsideSidebar={isInsideSidebar}
        userOpener={(sidebarOpener, user) => (
          <UserLink
            user={{ id: user.id, first_name: user.firstName, last_name: user.lastName }}
            sidebarOpener={sidebarOpener}
          />
        )}
      />
    </FlexBox>
  )
}
